module.exports = __webpack_public_path__ + "static/media/systemintelligent.8b5961a1.webp";